import Button from '@ui/button';
import { TransactionStatus } from '@constants/transaction-status';
import { type FC, memo } from 'react';
import transaction2 from '@assets/images/vault/transaction2.svg';
import transaction3 from '@assets/images/vault/transaction3.svg';
import suivison from '@assets/images/vault/suivison.svg';
import styles from './index.module.scss';
import { useModel } from 'foca';
import { transactionModel } from '@models/transaction.model';
import { globalSettingModel } from '@models/global-setting.model';
import Dialog from '@ui/parrot/dialog';
import Lottie from 'lottie-react';
import loadingJSON from '@assets/lottie/vault/loading.json';

const Transaction: FC = () => {
  const {
    status,
    digest,
    visible,
    description = 'Confirm this transaction in your wallet',
    title,

    successTitle = 'Transaction Completed',
    successDescription,

    errorTitle = 'Transaction failed',
    errorDescription = 'User rejected the request',
  } = useModel(transactionModel);
  const closable = status === TransactionStatus.success || status === TransactionStatus.fail;

  let _title = title;
  let _description = description;

  if (status === TransactionStatus.success) {
    _title = successTitle || _title;
    _description = successDescription || _description;
  } else if (status === TransactionStatus.fail) {
    _title = errorTitle || _title;
    _description = errorDescription || _description;
  }

  return (
    <Dialog
      isShown={visible}
      width={400}
      title={''}
      onCloseComplete={transactionModel.toggleVisible}
      center={true}
    >
      {({ close }: { close: () => void }) => (
        <div className={styles.inner}>
          {status === TransactionStatus.confirm && (
            <div className={styles.flex_center}>
              <Lottie animationData={loadingJSON} autoplay loop className={styles.lottie} />
            </div>
          )}
          {status === TransactionStatus.success && (
            <div className={styles.img}>
              <img src={transaction2} />
            </div>
          )}
          {status === TransactionStatus.fail && (
            <div className={styles.img}>
              <img src={transaction3} />
            </div>
          )}

          <div className={styles.title}>{_title}</div>
          <div
            className={`${styles.desc} ${
              status === TransactionStatus.success
                ? styles.desc_2
                : status === TransactionStatus.fail
                ? styles.desc_1
                : ''
            }`}
          >
            {_description}
          </div>

          {/* {finishedTime ? (
          <div className={styles.time}> Finalized in {finishedTime} seconds</div>
        ) : null} */}

          {closable && (
            <div className={styles.close_button}>
              <Button onClick={close}>Close</Button>
            </div>
          )}

          {status === TransactionStatus.success && !!digest ? (
            <div className={styles.explorer}>
              View on
              <a href={globalSettingModel.explorerUrlForTransaction(digest)} target="_blank">
                <img src={suivison} />
              </a>
            </div>
          ) : null}
        </div>
      )}
    </Dialog>
  );
};

export default memo(Transaction);
